// extracted by mini-css-extract-plugin
export var button = "Button_button__zEOqE";
export var cancel = "Button_cancel__nuQYO";
export var md = "768px";
export var primary = "Button_primary__wRpZz";
export var primaryInverse = "Button_primaryInverse__s1bQU";
export var shared = "\"../../shared.module.css\"";
export var tertiary = "Button_tertiary__yDO8H";
export var tertiaryInverse = "Button_tertiaryInverse__quHID";